/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReservationRequestReservationPolicy
 */
export interface CreateReservationRequestReservationPolicy {
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservationPolicy
     */
    type: CreateReservationRequestReservationPolicyTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequestReservationPolicy
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestReservationPolicy
     */
    method?: CreateReservationRequestReservationPolicyMethodEnum;
}


/**
 * @export
 */
export const CreateReservationRequestReservationPolicyTypeEnum = {
    Card: 'CARD',
    Deposit: 'DEPOSIT',
    None: 'NONE'
} as const;
export type CreateReservationRequestReservationPolicyTypeEnum = typeof CreateReservationRequestReservationPolicyTypeEnum[keyof typeof CreateReservationRequestReservationPolicyTypeEnum];

/**
 * @export
 */
export const CreateReservationRequestReservationPolicyMethodEnum = {
    All: 'ALL',
    ByPerson: 'BY-PERSON',
    LargeGroups: 'LARGE-GROUPS'
} as const;
export type CreateReservationRequestReservationPolicyMethodEnum = typeof CreateReservationRequestReservationPolicyMethodEnum[keyof typeof CreateReservationRequestReservationPolicyMethodEnum];


/**
 * Check if a given object implements the CreateReservationRequestReservationPolicy interface.
 */
export function instanceOfCreateReservationRequestReservationPolicy(value: object): value is CreateReservationRequestReservationPolicy {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function CreateReservationRequestReservationPolicyFromJSON(json: any): CreateReservationRequestReservationPolicy {
    return CreateReservationRequestReservationPolicyFromJSONTyped(json, false);
}

export function CreateReservationRequestReservationPolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservationRequestReservationPolicy {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'method': json['method'] == null ? undefined : json['method'],
    };
}

export function CreateReservationRequestReservationPolicyToJSON(json: any): CreateReservationRequestReservationPolicy {
    return CreateReservationRequestReservationPolicyToJSONTyped(json, false);
}

export function CreateReservationRequestReservationPolicyToJSONTyped(value?: CreateReservationRequestReservationPolicy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'amount': value['amount'],
        'method': value['method'],
    };
}

